'use strict';

import { PLAN_SIZE } from 'ck-core/source/data/PlanSize';

export const lang = {
	SIZE_DESCRIPTIONS: {
		[PLAN_SIZE.INDIVIDUAL]: 'Great for one kid learning to code',
		[PLAN_SIZE.FAMILY]: `Great for a family of aspiring coders
Includes 5 accounts`
	},
	CHANGE_SUBSCRIPTION_MESSAGE: `You are currently paying $oldAmount every $oldInterval.

From $paymentDate you will be paying $newAmount every $newInterval instead.`,

	SUCCESS: {
		title: 'Success',
		message: 'Your payment has been processed successfully',
		email: 'A confirmation email has been sent to $[email].',
		hadPassword: {
			title: 'Thanks for your continued support'
		},
		setupPassword: {
			title: 'Final Step',
			canSetupPassword: 'You can set up a password to login to your account.',
			canSkip:
				'If you skip this, you can always access your account using the link in your confirmation email.'
		}
	}
};
